module.exports = __webpack_public_path__ + "static/game-0c4762bd4af1507bca888acc0d328073.svg";